import { isPointInText } from '../isPointInText';

export const handleLineSelection = (
  x,
  y,
  createdLines,
  tolerance,
  setIsDragging,
  setDragPointIndex,
  setDragPoint,
  clearAllSelections,
  dispatch,
  setSelectedTool,
  setSelectedLine
) => {
  for (const line of createdLines) {
    if (line.points) {
      for (let i = 0; i < line.points.length; i++) {
        const point = line.points[i];
        const dist = Math.sqrt((x - point.x) ** 2 + (y - point.y) ** 2);
        if (dist <= tolerance) {
          setIsDragging(true);
          setDragPointIndex(i);
          clearAllSelections();
          dispatch(setSelectedTool('line'));
          dispatch(setSelectedLine(line));
          return true;
        }
      }
    } else {
      const startDist = Math.sqrt(
        (x - line.startX) ** 2 + (y - line.startY) ** 2
      );
      const endDist = Math.sqrt((x - line.endX) ** 2 + (y - line.endY) ** 2);

      if (startDist <= tolerance) {
        setIsDragging(true);
        setDragPoint('start');
        clearAllSelections();
        dispatch(setSelectedTool('line'));
        dispatch(setSelectedLine(line));
        return true;
      } else if (endDist <= tolerance) {
        setIsDragging(true);
        setDragPoint('end');
        clearAllSelections();
        dispatch(setSelectedTool('line'));
        dispatch(setSelectedLine(line));
        return true;
      }
    }
  }
  return false;
};

export const handleArrowSelection = (
  x,
  y,
  createdArrows,
  tolerance,
  setIsDragging,
  setDragPoint,
  clearAllSelections,
  dispatch,
  setSelectedTool,
  setSelectedArrow
) => {
  for (const arrow of createdArrows) {
    const startDist = Math.sqrt(
      (x - arrow.startX) ** 2 + (y - arrow.startY) ** 2
    );
    const endDist = Math.sqrt((x - arrow.endX) ** 2 + (y - arrow.endY) ** 2);

    if (startDist <= tolerance) {
      setIsDragging(true);
      setDragPoint('start');
      clearAllSelections();
      dispatch(setSelectedTool('arrow'));
      dispatch(setSelectedArrow(arrow));
      return true;
    } else if (endDist <= tolerance) {
      setIsDragging(true);
      setDragPoint('end');
      clearAllSelections();
      dispatch(setSelectedTool('arrow'));
      dispatch(setSelectedArrow(arrow));
      return true;
    }
  }
  return false;
};

export const handleTextSelection = (
  x,
  y,
  createdTexts,
  canvasRef,
  setIsDragging,
  clearAllSelections,
  dispatch,
  setSelectedTool,
  setSelectedText
) => {
  for (const text of createdTexts) {
    if (isPointInText(canvasRef, { x, y }, text)) {
      setIsDragging(true);
      clearAllSelections();
      dispatch(setSelectedTool('text'));
      dispatch(setSelectedText(text));
      return true;
    }
  }
  return false;
};

export const handleAreaSelection = (
  x,
  y,
  createdAreas,
  tolerance,
  setIsDragging,
  setDragPointIndex,
  clearAllSelections,
  dispatch,
  setSelectedTool,
  setSelectedArea
) => {
  for (const area of createdAreas) {
    if (!area.points) continue;
    for (let i = 0; i < area.points.length; i++) {
      const point = area.points[i];
      const dist = Math.sqrt((x - point.x) ** 2 + (y - point.y) ** 2);
      if (dist <= tolerance) {
        setIsDragging(true);
        setDragPointIndex(i);
        clearAllSelections();
        dispatch(setSelectedTool('area'));
        dispatch(setSelectedArea(area));
        return true;
      }
    }
  }
  return false;
};

export const handleSquareSelection = (
  x,
  y,
  createdSquares,
  tolerance,
  setIsDragging,
  setDragPoint,
  clearAllSelections,
  dispatch,
  setSelectedTool,
  setSelectedSquare
) => {
  for (const square of createdSquares) {
    const topLeftDist = Math.sqrt((x - square.x) ** 2 + (y - square.y) ** 2);
    const topRightDist = Math.sqrt(
      (x - (square.x + square.width)) ** 2 + (y - square.y) ** 2
    );
    const bottomLeftDist = Math.sqrt(
      (x - square.x) ** 2 + (y - (square.y + square.height)) ** 2
    );
    const bottomRightDist = Math.sqrt(
      (x - (square.x + square.width)) ** 2 +
        (y - (square.y + square.height)) ** 2
    );

    if (topLeftDist <= tolerance) {
      setIsDragging(true);
      setDragPoint('topLeft');
      clearAllSelections();
      dispatch(setSelectedTool('square'));
      dispatch(setSelectedSquare(square));
      return true;
    } else if (topRightDist <= tolerance) {
      setIsDragging(true);
      setDragPoint('topRight');
      clearAllSelections();
      dispatch(setSelectedTool('square'));
      dispatch(setSelectedSquare(square));
      return true;
    } else if (bottomLeftDist <= tolerance) {
      setIsDragging(true);
      setDragPoint('bottomLeft');
      clearAllSelections();
      dispatch(setSelectedTool('square'));
      dispatch(setSelectedSquare(square));
      return true;
    } else if (bottomRightDist <= tolerance) {
      setIsDragging(true);
      setDragPoint('bottomRight');
      clearAllSelections();
      dispatch(setSelectedTool('square'));
      dispatch(setSelectedSquare(square));
      return true;
    }
  }
  return false;
};

export const handleCircleSelection = (
  x,
  y,
  createdCircles,
  tolerance,
  setIsDragging,
  setDragPoint,
  clearAllSelections,
  dispatch,
  setSelectedTool,
  setSelectedCircle
) => {
  for (const circle of createdCircles) {
    const topDist = Math.sqrt(
      (x - circle.centerX) ** 2 + (y - (circle.centerY - circle.radiusY)) ** 2
    );
    const rightDist = Math.sqrt(
      (x - (circle.centerX + circle.radiusX)) ** 2 + (y - circle.centerY) ** 2
    );
    const bottomDist = Math.sqrt(
      (x - circle.centerX) ** 2 + (y - (circle.centerY + circle.radiusY)) ** 2
    );
    const leftDist = Math.sqrt(
      (x - (circle.centerX - circle.radiusX)) ** 2 + (y - circle.centerY) ** 2
    );

    if (topDist <= tolerance) {
      setIsDragging(true);
      setDragPoint('top');
      clearAllSelections();
      dispatch(setSelectedTool('circle'));
      dispatch(setSelectedCircle(circle));
      return true;
    } else if (rightDist <= tolerance) {
      setIsDragging(true);
      setDragPoint('right');
      clearAllSelections();
      dispatch(setSelectedTool('circle'));
      dispatch(setSelectedCircle(circle));
      return true;
    } else if (bottomDist <= tolerance) {
      setIsDragging(true);
      setDragPoint('bottom');
      clearAllSelections();
      dispatch(setSelectedTool('circle'));
      dispatch(setSelectedCircle(circle));
      return true;
    } else if (leftDist <= tolerance) {
      setIsDragging(true);
      setDragPoint('left');
      clearAllSelections();
      dispatch(setSelectedTool('circle'));
      dispatch(setSelectedCircle(circle));
      return true;
    }
  }
  return false;
};

export const handleLegendSelection = (
  x,
  y,
  createdLegends,
  tolerance,
  setIsDragging,
  setDragPoint,
  clearAllSelections,
  dispatch,
  setSelectedTool,
  setSelectedLegend
) => {
  for (const legend of createdLegends) {
    const topLeftDist = Math.sqrt((x - legend.x) ** 2 + (y - legend.y) ** 2);
    const topRightDist = Math.sqrt(
      (x - (legend.x + legend.width)) ** 2 + (y - legend.y) ** 2
    );
    const bottomLeftDist = Math.sqrt(
      (x - legend.x) ** 2 + (y - (legend.y + legend.height)) ** 2
    );
    const bottomRightDist = Math.sqrt(
      (x - (legend.x + legend.width)) ** 2 +
        (y - (legend.y + legend.height)) ** 2
    );

    if (topLeftDist <= tolerance) {
      setIsDragging(true);
      setDragPoint('topLeft');
      clearAllSelections();
      dispatch(setSelectedTool('legend'));
      dispatch(setSelectedLegend(legend));
      return true;
    } else if (topRightDist <= tolerance) {
      setIsDragging(true);
      setDragPoint('topRight');
      clearAllSelections();
      dispatch(setSelectedTool('legend'));
      dispatch(setSelectedLegend(legend));
      return true;
    } else if (bottomLeftDist <= tolerance) {
      setIsDragging(true);
      setDragPoint('bottomLeft');
      clearAllSelections();
      dispatch(setSelectedTool('legend'));
      dispatch(setSelectedLegend(legend));
      return true;
    } else if (bottomRightDist <= tolerance) {
      setIsDragging(true);
      setDragPoint('bottomRight');
      clearAllSelections();
      dispatch(setSelectedTool('legend'));
      dispatch(setSelectedLegend(legend));
      return true;
    }
  }
  return false;
};
